import React from 'react';
import { hot } from 'react-hot-loader';
import ButtonElement from '../../Elements/Button/Button';
import { purifier, scrollTo, offset } from '../../../utils/dom';
import { cleanInternalLinks, camelCase } from '../../../utils/string';

const Button = ({ content, attrs = {}, isManyButtons = 1, inline }) => {
	const variantClasses = ['button__content'];
	const style = {};

	if (isManyButtons > 1) variantClasses.push('button__multiple');
	if (attrs.outline) variantClasses.push('button__outline');
	if (attrs.fullWidth) variantClasses.push('button__fullWidth');
	if (attrs.fontSize) variantClasses.push(`button__${attrs.fontSize}`);
	if (attrs.width) variantClasses.push(`button__${attrs.width}`);
	if (attrs.className) variantClasses.push(`button_${attrs.className}`);
	if (attrs.backgroundColor) {
		style.backgroundColor = attrs.backgroundColor;
		style.borderColor = attrs.backgroundColor;
	}
	if (attrs.borderRadius) style.borderRadius = attrs.borderRadius.join(' ');
	if (attrs.textColor) {
		style.color = attrs.textColor;
		if (attrs.textColor === '#FDFDFD') style.fontWeight = '700';
	}
	if (content?.attrs?.style && content.attrs.style.indexOf(':') !== -1) {
		content.attrs.style.split(';').forEach((p) => {
			const [key, value] = p.split(':');
			style[camelCase(key)] = value;
		});
	}
	if (inline) variantClasses.push('button__plpButton');

	if (!content.rawText) return null;

	const clickEventHandler = (e) => {
		const link = e.currentTarget.getAttribute('href');
		if (/^#/.test(link) && document.getElementById(link.slice(1))) {
			e.preventDefault();
			const linkOffset = offset(document.getElementById(link.slice(1)));
			scrollTo(300, linkOffset.top - 60);
		}
	};

	return (
		<ButtonElement type="link" location={cleanInternalLinks(content.attrs.href)} variantClasses={variantClasses} clickEventHandler={clickEventHandler} style={Object.keys(style).length > 0 ? style : null}>
			<span dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
		</ButtonElement>
	);
};

export default hot(module)(Button);
